<div class="auth-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-6 col-lg-5 col-xl-4">
                <div class="card h-auto">
                    <div class="card-body">
                        <div class="text-center mb-4">
                            <a><img class="logo-auth" src="../../../../../assets/images/logo.svg" alt="logo"/></a>
                        </div>
                        <spinner *ngIf="loading"></spinner>
                        <h4 class="text-center mb-4">Sign In</h4>
                        <form [formGroup]="form" (ngSubmit)="onSubmit()">
                            <div class="form-group mb-3">
                                <label class="form-label" for="type">Select the platform:</label>
                                <select formControlName="type" class="form-select">
                                    <option value="">Select one option</option>
                                    <option *ngIf="type !== 'cdssadmin'" value="ctms">Clinical Trials (CTMS)</option>
                                    <option value="cdss">Clinical Practise (CDSS)</option>
                                    <option *ngIf="roles" value="admin">Admin Back-Office</option>
                                </select>
                                @if (form.get('type').invalid && (form.get('type').dirty || form.get('type').touched)) {
                                    <div class="text-danger">This field is required and must be valid.</div>
                                }
                            </div>

                            <div class="text-center">
                                <button type="submit" class="btn btn-success" [disabled]="form.invalid">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
